(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Announcement rotation */
  $$('[data-announcement]').forEach(function (track) {
    var items = $$('.announcement__item', track);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* Mobile nav */
  var navToggle = $('[data-nav-toggle]');
  var mobileNav = $('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = mobileNav.hasAttribute('hidden');
      if (open) mobileNav.removeAttribute('hidden'); else mobileNav.setAttribute('hidden', '');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    $$('a', mobileNav).forEach(function (a) {
      a.addEventListener('click', function () { mobileNav.setAttribute('hidden', ''); navToggle.setAttribute('aria-expanded', 'false'); });
    });
  }

  /* Gallery */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('[data-gallery-track]', g);
    var slides = $$('.gallery__slide', g);
    var thumbs = $$('[data-thumb]', g);
    var dots = $$('.gallery__dots span', g);
    function setActive(idx) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setActive(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    /* Show only the images that belong to the chosen variant (matched on alt text) */
    g.filterGallery = function (title) {
      if (!title) return;
      var any = slides.some(function (s) { return (s.getAttribute('data-alt') || '').indexOf(title) > -1; });
      if (!any) return;
      var first = -1;
      slides.forEach(function (s, i) {
        var hide = (s.getAttribute('data-alt') || '').indexOf(title) === -1;
        s.classList.toggle('is-hidden', hide);
        if (thumbs[i]) thumbs[i].classList.toggle('is-hidden', hide);
        if (dots[i]) dots[i].classList.toggle('is-hidden', hide);
        if (!hide && first === -1) first = i;
      });
      setActive(first);
      if (track) track.scrollLeft = 0;
    };
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          if (window.innerWidth >= 900) return;
          var visible = dots.filter(function (d) { return !d.classList.contains('is-hidden'); });
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          visible.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        });
      }, { passive: true });
    }
  });

  /* Quantity */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = $('[data-qty-input]', (minus || plus).closest('[data-qty]'));
    var v = parseInt(input.value, 10) || 1;
    v = minus ? Math.max(1, v - 1) : Math.min(20, v + 1);
    input.value = v;
  });

  /* Variant selection */
  $$('[data-product-form]').forEach(function (form) {
    var json = $('[data-variants]', form);
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var readyLabel = form.hasAttribute('data-direct-checkout') ? 'Köp nu' : 'Lägg i varukorgen';
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      var selected = $$('[data-option-index]:checked', form).map(function (r) { return r.value; });
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
      var label = $('[data-option-label="' + e.target.getAttribute('data-option-index') + '"]', form);
      if (label) label.textContent = e.target.value;
      var btn = $('[data-add-btn]', form);
      var lbl = $('[data-add-label]', form);
      if (match) {
        $('[data-variant-id]', form).value = match.id;
        btn.disabled = !match.available;
        lbl.textContent = match.available ? readyLabel : 'Slutsåld';
        var section = form.closest('[data-product-section]');
        var price = section && $('.price__current', section);
        if (price) price.textContent = formatMoney(match.price);
        var gallery = section && $('[data-gallery]', section);
        if (gallery && gallery.filterGallery) gallery.filterGallery(match.title);
        if (history.replaceState && section && !section.classList.contains('product--featured')) {
          var url = new URL(location.href); url.searchParams.set('variant', match.id); history.replaceState({}, '', url);
        }
      } else {
        btn.disabled = true; lbl.textContent = 'Ej tillgänglig';
      }
    });
  });

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} kr';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals' || key === 'amount_no_decimals_with_comma_separator' || key === 'amount_no_decimals_with_space_separator') return whole;
      if (key === 'amount_with_comma_separator') return whole + ',' + parts[1];
      return whole + '.' + parts[1];
    });
  }

  /* Cart drawer */
  var drawer = $('[data-cart-drawer]');
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) { location.href = window.theme.routes.cart_url; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    setTimeout(function () { var p = $('.drawer__panel', drawer); if (p) p.focus(); }, 50);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  if (drawer && window.theme && window.theme.cartDrawer) {
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    });
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  }

  function refreshCart() {
    return fetch(window.theme.routes.root + '?sections=cart-drawer,cart-count')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var content = $('[data-cart-drawer-content]');
        if (content && data['cart-drawer']) content.innerHTML = stripWrapper(data['cart-drawer']);
        var page = $('[data-cart-page]');
        if (page && data['cart-drawer']) page.innerHTML = stripWrapper(data['cart-drawer']);
        if (data['cart-count']) {
          $$('[data-cart-count-wrap]').forEach(function (w) {
            w.innerHTML = stripWrapper(data['cart-count']);
            var c = $('[data-cart-count]', w); if (c) { c.classList.add('bump'); }
          });
        }
      });
  }
  function stripWrapper(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    var inner = div.firstElementChild;
    return inner && inner.classList.contains('shopify-section') ? inner.innerHTML : html;
  }

  /* Add to cart – or straight to checkout for "Köp nu" forms */
  $$('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var direct = form.hasAttribute('data-direct-checkout');
      if (!direct && (!window.theme || !window.theme.cartDrawer || !drawer)) return;
      e.preventDefault();
      var btn = $('[data-add-btn]', form);
      var err = $('[data-form-error]', form);
      var leaving = false;
      btn.classList.add('is-loading'); btn.disabled = true; err.hidden = true;
      var fd = new FormData(form);
      fd.delete('return_to');
      fetch(window.theme.routes.cart_add_url, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Något gick fel. Försök igen.');
          if (direct) { leaving = true; window.location.href = '/checkout'; return; }
          return refreshCart().then(openDrawer);
        })
        .catch(function (ex) { err.textContent = ex.message; err.hidden = false; })
        .finally(function () { if (!leaving) { btn.classList.remove('is-loading'); btn.disabled = false; } });
    });
  });

  /* Cart line changes */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    var line = parseInt(b.getAttribute('data-line-change'), 10);
    var qty = Math.max(0, parseInt(b.getAttribute('data-qty'), 10));
    b.disabled = true;
    fetch(window.theme.routes.cart_change_url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(refreshCart).catch(function () { location.reload(); });
  });

  /* Sticky buy bar (product page) */
  var sticky = $('[data-sticky-buy]');
  var mainForm = $('.section-main-product [data-product-form]') || $('[data-product-section]:not(.product--featured) [data-product-form]');
  if (sticky && mainForm && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var addBtn = $('[data-add-btn]', mainForm);
    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      sticky.classList.toggle('is-visible', !visible);
    }).observe(addBtn);
    $('[data-sticky-add]', sticky).addEventListener('click', function () {
      if (addBtn.disabled) return;
      if (mainForm.requestSubmit) mainForm.requestSubmit(addBtn); else addBtn.click();
    });
  }

  /* Order deadline countdown text */
  $$('[data-deadline]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-deadline'));
    var out = $('[data-deadline-left]', el);
    if (isNaN(end) || !out) return;
    var days = Math.ceil((end - new Date()) / 86400000);
    if (days <= 0) { el.hidden = true; return; }
    out.textContent = days === 1 ? 'Sista dagen idag!' : 'Det är ' + days + ' dagar kvar.';
  });
})();
